import React from "react";

class CourseGrid extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        const {title, link, courses} = this.props;
        return (
            <div>
                <div className="row">
                    <div className="col-md-8">
                        <h4>{title} - <a href={link}>{link}</a></h4>
                    </div>
                </div>
                <div className="row">
                    {this.loadCourseContent(courses)}
                </div>
            </div>
        );
    }

    loadCourseContent(courses) {
        return courses.map((course, id) =>
            <div className="col-md-4 mb-3" key={id}>
                <div className="card h-100 justify-content-center">
                    <a href={course.link} target="_blank" rel="noopener noreferrer">
                        <div className="card-body">
                            <h5>{course.title}</h5>
                        </div>
                    </a>
                </div>
            </div>
        );
    }

}

CourseGrid.propTypes = {};

export default CourseGrid;
